export default "__VITE_ASSET__4gYBORqh__"